import React from 'react';
import { Link } from 'gatsby-plugin-react-i18next';
import PropTypes from 'prop-types';
import useLanguage from '../../../hooks/useLanguage';
import {fromBlogSlugToUrl} from '../../../utils/slug'
import {fromArticleSlugToUrl} from '../../../utils/slug'

const CrumbsNav = ({ crumbsData, crumbsCat, crumbsArticle }) => {
  const langToggle = useLanguage;
  return (
    <section className="crumbs-nav__section" data-scroll-section>
      <div className="content-wrapper">
        <ul className="crumbs-nav">
          {crumbsData.map((item, index) => {
            return (
              <li className="crumbs-nav__item" key={index}>
                <Link className="crumbs-naw__item-link" to={item.link}>
                  {langToggle(item.title_ua, item.title_ru)}
                </Link>
              </li>
            );
          })}
            <li className={crumbsCat ? "crumbs-nav__item" : null}>
                <Link className="crumbs-naw__item-link" to={crumbsCat ? fromBlogSlugToUrl(crumbsCat.slug) : null}>
                  {crumbsCat ? langToggle(crumbsCat.title_ua, crumbsCat.title_ru) : null}
                </Link>
            </li>
            <li className={crumbsArticle ? "crumbs-nav__item" : null}>
                <Link className="crumbs-naw__item-link" to={crumbsArticle ? fromArticleSlugToUrl(crumbsArticle.slug) : null}>
                  {crumbsArticle ? langToggle(crumbsArticle.title_ua, crumbsArticle.title_ru) : null}
                </Link>
            </li>
        </ul>
      </div>
    </section>
  );
};

CrumbsNav.propTypes = {
  crumbsData: PropTypes.array,
};

export default CrumbsNav;
